<template>
  <div class="row q-col-gutter-sm items-center justify-center full-width">
    <div
      v-for="btn, index in NPS_RESPONSE_BUTTONS_PROPS"
      :key="index"
      class="col-auto col-sm-1"
    >
      <q-btn
        @click="selectButton(btn)"
        class="fit"
        :color="btn.color"
        push
        :outline="modelVal === btn.value"
        :class="{ 'selectedButton' : modelVal === btn.value}"
      >
        <span :class="{ 'text-white' : $q.dark.isActive }">
          {{ btn.value }}
        </span>
      </q-btn>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, defineProps } from 'vue'
import { useFormChild, useQuasar } from 'quasar'

import { isTruthyValue } from 'src/utils'
import { NPS_RESPONSE_BUTTONS_PROPS } from 'src/constants/nps'

export default defineComponent({
  name: 'NpsResponseButtons'
})

</script>

<script setup>

const props = defineProps({
  modelValue: Number,
  required: Boolean
})

const emit = defineEmits(
  ['update:modelValue']
)

const $q = useQuasar()

const modelVal = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    emit('update:modelValue', newValue)
  }
})

const selectButton = (btn) => {
  modelVal.value = btn.value
}

const validate = () => {
  if (!props.required) return true

  if (!isTruthyValue(modelVal.value, { allowZero: true })) {
    $q.notify({
      type: 'alert',
      message: 'Atribua uma nota de 0 a 10 para prosseguir.'
    })
    return false
  }

  return true
}

useFormChild({ validate })

</script>

<style lang="scss">

.selectedButton {
  border-radius: 7px;
  border-bottom: 2px solid;
  box-shadow: 0px 3px 5px rgba(0,0,0,0.2);
}

</style>
